/**
 * The "Reference · de.lexicon · 49 entries" microheader that prefaces
 * every reference / admin page. Same flex-wrap layout, same hidden
 * separator dots, same mono treatment for the domain slug.
 *
 * Eight pages were copy-pasting it (browse, lexicon, constructions,
 * skills, admin.users, admin.reports, progress, progress.skill).
 */

import type { ReactNode } from "react";

type PageEyebrowProps = {
  /** Domain bucket — "Reference", "Admin", "Progress", etc. */
  label: ReactNode;
  /** Mono-styled slug — e.g. `de.lexicon`, `users`, `admin.reports`. */
  mono?: ReactNode;
  /** Right-side count — e.g. "49 entries". */
  count?: ReactNode;
};

export function PageEyebrow({ label, mono, count }: PageEyebrowProps) {
  return (
    <div className="eyebrow mb-3 flex flex-wrap items-center gap-x-2 gap-y-1">
      <span>{label}</span>
      {mono != null && (
        <>
          <Dot />
          <span className="font-mono normal-case tracking-normal text-ink-500">
            {mono}
          </span>
        </>
      )}
      {count != null && (
        <>
          <Dot />
          <span className="tabular-nums">{count}</span>
        </>
      )}
    </div>
  );
}

function Dot() {
  return (
    <span aria-hidden className="text-ink-300">
      ·
    </span>
  );
}
